import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, PlanzoneSettings } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editWbsConfiguration(
    req: Boundaries["editWbsConfiguration"]["request"],
  ): void;
}

function useEditWbsConfiguration(planzone: Identifiable<Planzone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditWbsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditWbsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditWbsConfigurationRequestFailure(planzone),
    ),
    editWbsConfiguration: core.editWbsConfiguration,
  };
}

export { useEditWbsConfiguration };
